import {
  ElectronPushTokenErrorCode,
  PushRegistrationError,
} from 'shared/types/electron';

export const getPushErrorTranslationKey = (error: unknown): string => {
  if (
    error instanceof PushRegistrationError &&
    error.code === ElectronPushTokenErrorCode.PermissionDenied
  ) {
    return 'forms.user-settings.sections.notifications.error.permission-denied-os';
  }
  return window.electron
    ? 'forms.user-settings.sections.notifications.error.toggle-failed-in-app'
    : 'forms.user-settings.sections.notifications.error.toggle-failed-in-browser';
};
